"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendMessage;
exports.SEND_MESSAGE = void 0;
var SEND_MESSAGE = 'WEB_CHAT/SEND_MESSAGE';
exports.SEND_MESSAGE = SEND_MESSAGE;

function sendMessage(text, method) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      channelData = _ref.channelData;

  return {
    type: SEND_MESSAGE,
    payload: {
      channelData: channelData,
      method: method,
      text: text
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hY3Rpb25zL3NlbmRNZXNzYWdlLmpzIl0sIm5hbWVzIjpbIlNFTkRfTUVTU0FHRSIsInNlbmRNZXNzYWdlIiwidGV4dCIsIm1ldGhvZCIsImNoYW5uZWxEYXRhIiwidHlwZSIsInBheWxvYWQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxZQUFZLEdBQUcsdUJBQXJCOzs7QUFFZSxTQUFTQyxXQUFULENBQXFCQyxJQUFyQixFQUEyQkMsTUFBM0IsRUFBeUQ7QUFBQSxpRkFBSixFQUFJO0FBQUEsTUFBcEJDLFdBQW9CLFFBQXBCQSxXQUFvQjs7QUFDdEUsU0FBTztBQUNMQyxJQUFBQSxJQUFJLEVBQUVMLFlBREQ7QUFFTE0sSUFBQUEsT0FBTyxFQUFFO0FBQUVGLE1BQUFBLFdBQVcsRUFBWEEsV0FBRjtBQUFlRCxNQUFBQSxNQUFNLEVBQU5BLE1BQWY7QUFBdUJELE1BQUFBLElBQUksRUFBSkE7QUFBdkI7QUFGSixHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBTRU5EX01FU1NBR0UgPSAnV0VCX0NIQVQvU0VORF9NRVNTQUdFJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZE1lc3NhZ2UodGV4dCwgbWV0aG9kLCB7IGNoYW5uZWxEYXRhIH0gPSB7fSkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNFTkRfTUVTU0FHRSxcbiAgICBwYXlsb2FkOiB7IGNoYW5uZWxEYXRhLCBtZXRob2QsIHRleHQgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRU5EX01FU1NBR0UgfTtcbiJdfQ==